<div class='loading'>
  <div class='loading-box middle'>
    <div style='padding:30px;'>
    <i class='fa fa-spinner fa-spin fa-2x'></i>&nbsp;&nbsp;<span style='font-size:larger;font-weight:bolder'>Loading ... </span>
  </div>
  </div>
</div>